module.exports = __webpack_public_path__ + "img/trailer_back_left.3617710c.png";